@if (icon()) {
  <fa-icon class="boels-button__icon" [icon]="icon()!"></fa-icon>
}

<!-- display anything with the button element -->
<span class="boels-button__content" [ngClass]="{ 'no-icon': !icon() }">
  <ng-content></ng-content>
</span>

@if (iconAction) {
  <fa-icon
    class="boels-button__icon--action"
    [ngClass]="{ '-loading-icon': isLoading() }"
    [icon]="iconAction"
  ></fa-icon>
}
